import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../../util/util'

const styles = {
  containerList: { flexGrow: 1 } as ViewStyle,
  operatorContainer: { flex: 1 } as BoxProps,
  contantViewStyle: {
    // padding: 16,
    flex: 1,
  } as BoxProps,
  eduContantViewStyle: {
    // bg: 'WHITE',
    // flexGrow: 1,
    flex: 1,
  } as BoxProps,
  textStyle: {
    fontSize: 'FONT_SIZE_MEDIUM',
  } as TextProps,
  viewAll: {
    backgroundColor: 'WHITE',
    borderRadius: 15,
    justifyContent: 'center',
    width: 120,
    height: 30,
    right: 16,
    alignItems: 'center',
    position: 'absolute',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  titleEmpty: {
    color: Colors.PRIMARY_GREY,
    fontFamily: 'JioType-Medium',
    fontSize: 12,
    padding: 16,
    textAlign: 'center',
  } as TextProps,
  headerText: {
    color: '#555555' as ColorOptions,
    fontWeight: '500',
    fontSize: 18,
    // fontFamily:"JioType-SemiBold"
  } as TextProps,
  title: {
    fontFamily: 'JioType-Medium',
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: -0.08,
    color: Colors.BLACK_14,
  } as TextProps,
}

export default styles
